import { Box, Stack } from '@mui/material'
import { UserPermission } from 'models'
import ButtonWithLoading from './button_with_loading'
import { UnauthorisedError } from 'errors'
import { useContext, useEffect, useState } from 'react'
import { UserContext } from 'base'
import { PermissionSelector } from './telegram_user_form'

interface TelegramUserEditFormProps {
  existingPermissions: Array<UserPermission>
  onSubmit: (selectedPermission: Array<UserPermission>) => Promise<void>
}

export const TelegramUserEditForm = ({
  existingPermissions,
  onSubmit,
}: TelegramUserEditFormProps) => {
  const [selectedPermissions, setSelectedPermissions] = useState<
    Array<UserPermission>
  >([])

  const [isSaving, setIsSaving] = useState<boolean>(false)
  const user = useContext(UserContext)

  useEffect(() => {
    setSelectedPermissions(existingPermissions)
  }, [existingPermissions])

  const handlePermissionToggle = (permission: UserPermission) => {
    setSelectedPermissions((prev) =>
      prev.includes(permission)
        ? prev.filter((p) => p !== permission)
        : [...prev, permission]
    )
  }

  return (
    <Box
      component="form"
      onSubmit={async (event) => {
        setIsSaving(true)
        event.preventDefault()
        try {
          await onSubmit(selectedPermissions)
        } catch (e: any) {
          if (e instanceof UnauthorisedError) {
            user.setLoggedOut()
          }
        }
        setIsSaving(false)
      }}
    >
      <Stack spacing={3}>
        <PermissionSelector
          selectedPermissions={selectedPermissions}
          handlePermissionToggle={handlePermissionToggle}
        />
        <Stack direction="row" justifyContent="right">
          <ButtonWithLoading
            type="submit"
            variant="contained"
            isLoading={isSaving}
          >
            Save
          </ButtonWithLoading>
        </Stack>
      </Stack>
    </Box>
  )
}
